import { getToken, onMessage } from "firebase/messaging";
import {
  getFirebaseMessaging,
  FIREBASE_VAPID_KEY,
  APP_VERSION,
} from "./firebase";
import { callAPI, callAPIForMember } from "../utils/apiUtils";
import { apiUrls } from "../utils/apiUrls";

const DEVICE_ID_KEY = "ggc_device_id";
const FCM_TOKEN_KEY = "fcmToken";

export const getDeviceId = () => {
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id = `web-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
};

const registerDeviceOnBackend = async (fcmToken) => {
  try {
    const payload = {
      deviceId: getDeviceId(),
      fcmToken,
      platform: "web",
      appVersion: APP_VERSION,
    };
    const isAdminRoute = window.location.pathname.startsWith("/admin");
    const apiFn = isAdminRoute ? callAPI : callAPIForMember;
    const res = await apiFn(apiUrls.notificationsDevices, {}, "POST", payload);
    if (res?.data?.success) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const requestPushPermission = async () => {
  try {
    if (!("Notification" in window) || !("serviceWorker" in navigator)) {
      console.warn("Push not supported in this browser.");
      return null;
    }

    if (!FIREBASE_VAPID_KEY) {
      console.warn("FIREBASE_VAPID_KEY is missing in config - push disabled.");
      return null;
    }

    const savedToken = localStorage.getItem(FCM_TOKEN_KEY);
    if (Notification.permission === "granted" && savedToken) {
      await registerDeviceOnBackend(savedToken);
      return savedToken;
    }

    if (Notification.permission === "denied") {
      console.warn("Notification permission previously denied.");
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission denied.");
      return null;
    }

    const messaging = await getFirebaseMessaging();
    if (!messaging) {
      console.warn("Firebase messaging not supported.");
      return null;
    }

    const registration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );
    await navigator.serviceWorker.ready;

    const token = await getToken(messaging, {
      vapidKey: FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: registration,
    });

    if (!token) {
      console.warn("No FCM token available.");
      return null;
    }

    const registered = await registerDeviceOnBackend(token);
    if (registered) localStorage.setItem(FCM_TOKEN_KEY, token);

    return token;
  } catch (error) {
    console.error("Push setup error:", error);
    return null;
  }
};

export const listenForForegroundMessages = async (onMessageReceived) => {
  const messaging = await getFirebaseMessaging();
  if (!messaging) return null;

  return onMessage(messaging, (payload) => {
    onMessageReceived?.(payload);
  });
};

export const hasPushPermission = () =>
  typeof Notification !== "undefined" && Notification.permission === "granted";

export const clearLocalPushState = () => {
  localStorage.removeItem(FCM_TOKEN_KEY);
};